<template>
  <div class="chat-box" v-if="showSelectors">
    <div class="chat-box-board">
      <div :class="{'is-loading':loading}" class="chat-box-board-selection">
        <div class="select">
          <label>Select recipient type</label>
          <select v-model="selectedRecipients">
            <option disabled value>Select type</option>
            <option
              v-for="(recipientType,index) in recipients"
              :key="index + 'recipient_type'"
              :value="recipientType"
            >{{recipientType.type}}</option>
          </select>
        </div>
        <div v-if="selectedRecipients !=null" class="select">
          <label>Select {{selectedRecipients.type}}</label>
          <select v-model="selectedRecipient">
            <option disabled value>Select recipient</option>
            <option
              v-for="recipient in selectedRecipients.users"
              :key="recipient.id"
              :value="recipient"
            >{{recipient.attributes.first_name}} {{recipient.attributes.last_name}}</option>
          </select>
        </div>
        <div v-if="selectedRecipient != null" class="buttons">
          <button class="button is-primary" @click="selectRecipient">Continue</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "chat-recipient-selector",
  data() {
    return {
      selectedRecipients: null,
      selectedRecipient: null,
    };
  },
  methods: {
    selectRecipient() {
      this.$emit("recipient-selected", {
        ...this.selectedRecipient,
        ...{ recipient_type: this.selectedRecipients.type },
      });
    },
  },
  props: {
    loading: {
      type: Boolean,
      default() {
        return false;
      },
    },
    showSelectors: {
      type: Boolean,
      default() {
        return false;
      },
    },
    recipients: {
      type: Array,
      default() {
        return [
          {
            type: "Mentor",
            users: [{ first_name: "bob", last_name: "frank", id: 1 }],
          },
        ];
      },
    },
  },
};
</script>